import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./styles/global.css";
import { registerSW } from "virtual:pwa-register";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

registerSW({ immediate: true });

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
